import fetch from 'utils/fetch'

export const reqParams = (data) => fetch('get', '/common/all_by_group', data)

export const reqParams222 = (data) => fetch('get', '/common/list_by_group', data)
